/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Branches_Status_ArchivedInputs */

const en_branches_status_archived = /** @type {(inputs: Branches_Status_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archived`)
};

const pt_br2_branches_status_archived = /** @type {(inputs: Branches_Status_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivada`)
};

/**
* | output |
* | --- |
* | "Archived" |
*
* @param {Branches_Status_ArchivedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const branches_status_archived = /** @type {((inputs?: Branches_Status_ArchivedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Branches_Status_ArchivedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_branches_status_archived(inputs)
	return pt_br2_branches_status_archived(inputs)
});